import { render, staticRenderFns } from "./parcel_lists.vue?vue&type=template&id=16afefbc&scoped=true"
import script from "./parcel_lists.js?vue&type=script&lang=js&external"
export * from "./parcel_lists.js?vue&type=script&lang=js&external"
import style0 from "./parcel_lists.vue?vue&type=style&index=0&id=16afefbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afefbc",
  null
  
)

export default component.exports